import { isNonFractionFact, type IXBRLElementNodeSerialized } from './IXBRLNode';
import type { LexicalEditor, SerializedLexicalNode } from 'lexical';

export function extractIdNumber(idString: string, prefix: string): number {
  if (!idString || !idString.startsWith(prefix)) {
    return 0;
  }
  const numPart = idString.substring(prefix.length);
  const parsed = parseInt(numPart, 10);
  return isNaN(parsed) ? 0 : parsed;
}

const isIXBRLElementNodeSerialized = (node?: SerializedLexicalNode): node is IXBRLElementNodeSerialized => {
  return !!node && node.type === 'ixbrl-element' && 'xbrl' in node;
};

export function getMaxIdsFromEditor(editor: LexicalEditor): { maxFactId: number; maxUnitRef: number; maxContextRef: number } {
  const editorStateJSON = editor.getEditorState().clone().toJSON();
  const stack: SerializedLexicalNode[] = editorStateJSON.root?.children ? [...editorStateJSON.root.children] : [];

  let maxFactId = 0;
  let maxUnitRef = 0;
  let maxContextRef = 0;
  
  while (stack.length > 0) {
    const node = stack.pop();

    if (isIXBRLElementNodeSerialized(node)) {
      const ixbrlNode = node;
      const xbrl = ixbrlNode.xbrl;

      const factIdNum = extractIdNumber(xbrl.factId, 'fact-');
      const unitRefNum = isNonFractionFact(xbrl) ? extractIdNumber(xbrl.unitRef, 'u-') : 0;
      const contextRefNum = extractIdNumber(xbrl.contextRef, 'c-');

      maxFactId = Math.max(maxFactId, factIdNum);
      maxUnitRef = Math.max(maxUnitRef, unitRefNum);
      maxContextRef = Math.max(maxContextRef, contextRefNum);
    }

    if (node && 'children' in node && Array.isArray(node.children)) {
      stack.push(...node.children);
    }
  }

  return { maxFactId, maxUnitRef, maxContextRef };
}
